/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Carry_NoneInputs */

const en_us2_workout_after_carry_none = /** @type {(inputs: Workout_After_Carry_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing selected: your plan stays as it is.`)
};

const pt_br2_workout_after_carry_none = /** @type {(inputs: Workout_After_Carry_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada marcado: o plano continua como está.`)
};

const es_419_workout_after_carry_none = /** @type {(inputs: Workout_After_Carry_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada seleccionado: tu plan queda como está.`)
};

const pt_pt2_workout_after_carry_none = /** @type {(inputs: Workout_After_Carry_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada marcado: o plano fica como está.`)
};

const fr_fr2_workout_after_carry_none = /** @type {(inputs: Workout_After_Carry_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rien de coché : ton programme reste tel quel.`)
};

const de_de2_workout_after_carry_none = /** @type {(inputs: Workout_After_Carry_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nichts ausgewählt: Dein Plan bleibt, wie er ist.`)
};

const it_it2_workout_after_carry_none = /** @type {(inputs: Workout_After_Carry_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niente selezionato: la scheda rimane com'è.`)
};

/**
* | output |
* | --- |
* | "Nothing selected: your plan stays as it is." |
*
* @param {Workout_After_Carry_NoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_carry_none = /** @type {((inputs?: Workout_After_Carry_NoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Carry_NoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_carry_none(inputs)
	if (locale === "es-419") return es_419_workout_after_carry_none(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_carry_none(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_carry_none(inputs)
	if (locale === "de-DE") return de_de2_workout_after_carry_none(inputs)
	if (locale === "it-IT") return it_it2_workout_after_carry_none(inputs)
	return en_us2_workout_after_carry_none(inputs)
});
export { workout_after_carry_none as "workout-after.carry_none" }